/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import Head from 'next/head'
import { useSelector } from 'react-redux'
import NoSSR from '@/components/rc-no-ssr'
import { getFenqiRecommend } from '../service'
import styles from './index.scss'
import CreditApply from '../module/credit-apply'
import CreditForm from '../module/credit-form'

const defaultImg = require('../../../assets/img/buy/default-car.png')


const InstallmentDetail = () => {
  const { city } = useSelector(store => store)
  const cityName = city.city_name || '全国'
  const [carData, setCarData] = useState([])
  const [linkUrl, setLinkUrl] = useState()
  const getFenqiRecommendFuc = async () => {
    try {
      const { data } = await getFenqiRecommend()
      const resultData = []
      const obj = data?.list
      const _linkUrl = typeof data.all_url === 'object' ? data.all_url.url : '/ershouche/pr-1-500_mi-0-15_ag-0-12_ft-qy/?pr=1-500&mi=0-15&ag=0-12&ft=qy_cy'
      resultData[0] = obj.shoufu
      resultData[1] = obj.yuegong
      resultData[2] = obj.sancheng
      resultData[3] = obj.nshoufu
      setCarData(resultData)
      setLinkUrl(`https://www.renrenche.com/${city.city || 'cn'}/${_linkUrl}`)
    } catch (error) {
      console.log(error)
    }
  }
  const gaRecommend = (tagValue, tagPosition) => {
    global.$rbl.push({
      event: 'LoanPage_CarRecommend_click',
      content: {
        expand: {
          tag_value: tagValue,
          tag_position: tagPosition
        }
      }
    })
  }
  useEffect(() => {
    getFenqiRecommendFuc()
  }, [])
  return (
    <>
      <Head>
        <title>{`【${cityName}二手车分期_${cityName}分期买二手车_${cityName}二手车按揭】-人人车`}</title>
        <meta name="keywords" content={`${cityName}二手车分期,${cityName}分期买二手车,${cityName}二手车按揭`} />
        <meta name="description" content={`${cityName}二手车分期,${cityName}按揭购买二手车,分期买${cityName}二手车,按揭买${cityName}二手车,咨询电话4000350113`} />
      </Head>
      <div className={styles['r-installment-detail']}>
        {/* banner区域 */}
        <div className="r-installment-detail__banner">
          <div className="inner-box">
            <div className="submit-box">
              <CreditForm title="申请分期购车" tag="专业顾问快速响应服务" submitSources="贷款-PC-分期页-首屏banner/提交申请" />
            </div>
            <div className="banner-pics">
              <div className="banner-tags">
                <p className="title">
                  <span>买车不用“筹”</span>
                  <span> 分期开好车</span>
                </p>
                <p className="tag">
                  <span>超低门槛</span>
                  <span>极速放款</span>
                  <span>全程服务</span>
                </p>
              </div>
              <div className="pic-box" />
            </div>
          </div>
        </div>
        {/* 贷款优势介绍 */}
        <div className="r-installment-detail__advantage">
          <ul className="inner-box">
            <li className="item">
              <i className="iconfont icon-dishoufu" />
              <p className="tag">
                <span className="font1">低首付</span>
                <span className="font2">首付低至3成</span>
              </p>
            </li>
            <li className="item">
              <i className="iconfont icon-fangikuankuai" />
              <p className="tag">
                <span className="font1">放款快</span>
                <span className="font2">最快当天放款</span>
              </p>
            </li>
            <li className="item">
              <i className="iconfont icon-dimenkan" />
              <p className="tag">
                <span className="font1">低门槛</span>
                <span className="font2">80%以上通过率</span>
              </p>
            </li>
            <li className="item">
              <i className="iconfont icon-dingzhihua" />
              <p className="tag">
                <span className="font1">定制化</span>
                <span className="font2">专业顾问全程服务</span>
              </p>
            </li>
          </ul>
        </div>
        {/* 分期好车推荐 */}
        <div className="r-installment-detail__car">
          <h3 className="title">分期好车推荐</h3>
          <ul className="advice-list">
            {carData.map((elt, index) => (
              <a key={index} href={`https://www.renrenche.com/${city.city || 'cn'}/ershouche/${elt?.url}`} onClick={() => { gaRecommend(elt.title, index) }}>
                <li className="advice-item">
                  <header className="advice-title">{elt.title}</header>
                  <p className="tag">{elt?.content}</p>
                  <div className="pic">
                    <img src={elt?.image} onError={e => e.target.src = defaultImg} alt="分期好车推荐" />
                  </div>
                </li>
              </a>
            ))}
          </ul>
          <div className="more-btn">
            <a href={linkUrl} onClick={() => { gaRecommend('查看全部', 'more') }}>全部车辆<i className="iconfont icon-middl_color_right-a4775df2" /></a>
          </div>
        </div>
        {/* 申请流程 */}
        <NoSSR>
          <div className="r-installment-detail__flow">
            <h3 className="title">申请流程</h3>
            <p className="tag">边申请边看车 购车更快更轻松</p>
            <ul className="num-list">
              <li className="num-item">1</li>
              <li className="num-item">2</li>
              <li className="num-item">3</li>
              <li className="num-item">4</li>
            </ul>
            <ul className="flow-list">
              <li className="flow-item">
                <div className="arrow-icon" />
                <p className="font1">在线申请</p>
                <p className="font2">专业顾问快速电话回访</p>
              </li>
              <li className="flow-item">
                <div className="arrow-icon" />
                <p className="font1">预约看车</p>
                <p className="font2">陪同看车 换车仍可分期</p>
              </li>
              <li className="flow-item">
                <div className="arrow-icon" />
                <p className="font1">快速审批</p>
                <p className="font2">资料提交 当天审批</p>
              </li>
              <li className="flow-item">
                <div className="arrow-icon" />
                <p className="font1">放款提车</p>
                <p className="font2">办理过户 当天放款</p>
              </li>
            </ul>
          </div>
          {/* 分期问答 */}
          <div className="r-installment-detail__ask">
            <h3 className="title">分期问答</h3>
            <ul className="ask-list">
              <li className="ask-item">
                <p className="ask-title">
                  <span className="ask-icon">Q1</span>在人人车买车如何申请分期？
                </p>
                <p className="ask-answer">您可以在人人车官网上点击“分期购车”详细了解分期服务并在线提交申请；也可拨打金融客服热线400-062-5503进行咨询；或者咨询线下顾问办理分期。</p>
              </li>
              <li className="ask-item">
                <p className="ask-title">
                  <span className="ask-icon">Q2</span>申请分期购车是否划算？
                </p>
                <p className="ask-answer">付个小首付、月还负担小。人人车与上百家金融机构合作，产品丰富，多种方案可选。可在线提交申请，金融顾问一对一专属沟通，定制金融方案。</p>
              </li>
              <li className="ask-item">
                <p className="ask-title">
                  <span className="ask-icon">Q3</span>申请分期流程是否麻烦？
                </p>
                <p className="ask-answer">申请简单、最快当天放款。人人车部分金融产品仅需身份证、驾驶证和银行卡即可申请，审批通过后金融顾问全程服务，具体以线下金融顾问告知为准。</p>
              </li>
              <li className="ask-item">
                <p className="ask-title">
                  <span className="ask-icon">Q4</span>办理分期后，如何还款呢？
                </p>
                <p className="ask-answer">您办理分期成功后，只要按照签订的融资合同上的每月还款日期，将每月还款金额提前打到绑定的还款银行卡上即可，系统会自动按时扣款。</p>
              </li>
              <li className="ask-item">
                <p className="ask-title">
                  <span className="ask-icon">Q5</span>申请办理分期还能砍价吗？
                </p>
                <p className="ask-answer">当然可以，办理分期不会影响您的线下砍价以及换车等，可以边申请边看车。</p>
              </li>
              <li className="ask-item">
                <p className="ask-title">
                  <span className="ask-icon">Q6</span>所有的车都可以申请分期吗？
                </p>
                <p className="ask-answer">不是的，新能源汽车以及车龄、车价超出限制的车不能申请分期，具体以顾问告知为准。</p>
              </li>
            </ul>
          </div>
        </NoSSR>
        {/* 咨询悬浮 */}
        <CreditApply submitSource="贷款-PC-分期页-左下角悬浮button/咨询顾问" fixed />
      </div>
    </>
  )
}
export default InstallmentDetail
